export const NAM_COUNTRIES_ENUM = {
  CA: 'CA',
  US: 'US'
}
